import React from 'react'
import {Box, Grid, Link, Typography} from '@mui/material'
import AlertIcon from 'assets/images/alert-circle-outline-icon.svg'
import 'features/HomePage/TrackShipments/index.scss'

interface NoHistoryProps {
    carrierDetails: Record<string, string>
}

const NoHistory: React.FC<NoHistoryProps> = ({carrierDetails}) => (
    <Box>
        <Grid container justifyContent='center' className='noHistory-container'>
            <Grid item xs={12} className='centered flex-col'>
                <Typography className='noHistory-bold-text'>
                    This carrier does not provide CPS with shipment history.
                </Typography>
                <Typography>
                    Please visit their{' '}
                    <Link href={carrierDetails?.websiteLink} target='_blank'>
                        website
                    </Link>{' '}
                    for more information.
                </Typography>
                <Box className='noHistory-img'>
                    <img src={AlertIcon} alt='icon' />
                </Box>
            </Grid>
        </Grid>
    </Box>
)

export default NoHistory
